import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LandingService } from 'src/app/modules/landing/landing.service';

@Component({
  selector: 'app-landing-footer',
  templateUrl: './landing-footer.component.html',
  styleUrls: ['./landing-footer.component.scss']
})
export class LandingFooterComponent {
  public agencyInfo$: Observable<any>;

  constructor(private _landingService: LandingService) {
    this.agencyInfo$ = this._landingService.agencyInfo$;
  }
}
